import { createApp } from 'vue'
import "./assets/scss/nprogress.css";
// 只引入自定义主题，内部包含全部组件样式+图标字体
import "./assets/scss/element-variables.scss"
import App from './App.vue'
import router from './router'
import store from './store'
import api from './api'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import './permission'
import dayjs from 'dayjs'

const app = createApp(App)
app.config.globalProperties.$api = api
app.config.globalProperties.$day = dayjs
app.use(router)
app.use(store)
app.use(ElementPlus, {
  locale: zhCn
})
app.config.productionTip = false
app.mount('#app')
